import { useQuery } from '@tanstack/react-query';

import AudiencesService from '@/services/AudiencesService';

export const AUDIENCE_NAMES_QUERY_KEY = ['audienceNames'];

export function useGetAudienceNames() {
  const { data, isFetching } = useQuery({
    queryKey: AUDIENCE_NAMES_QUERY_KEY,
    queryFn: () => AudiencesService.getAudienceNames(),
  });

  return {
    audienceNames: data?.audiences ?? [],
    isLoading: isFetching,
  };
}
